import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import { de } from '@fancyapps/ui/dist/carousel/l10n/de.esm.js';

// initializes slider blocks
const sliders = document.querySelectorAll(".indy-block-slider .f-carousel");

for(const slider of sliders) {
	const sliderOptions = {
		l10n: de,
		infinite: false,
		Dots: false,
		transition: "slide",
		Navigation: {
			nextTpl: slider.getAttribute('data-arrow-r'),
			prevTpl: slider.getAttribute('data-arrow-l'),
		}
	};

	new Carousel(slider, sliderOptions);
}